import { useAuthStore } from '../stores/auth-store';

/**
 * useTenantTier() → packageType do tenant da sessão (ou null).
 *
 * Origem: `tenant.packageType` populado pelo GET /v1/auth/me (RequireAuth).
 * Usado por gates tier-aware (ex.: A3 Branding — escrita requer Team+).
 */
export function useTenantTier(): string | null {
  return useAuthStore((s) => s.tenant?.packageType ?? null);
}
